export enum ReactModalDefaulClass {
  PORTAL_SMALL_SCREEN_BLOCKING = 'ReactModalPortal__SmallScreen',
  PORTAL_SMALL_SCREEN_NON_BLOCKING = 'ReactModalPortal__NonBlockingSmallScreen',
  CONTENT_BEFORE_CLOSE = 'ReactModal__Content--before-close',
  CONTENT_AFTER_OPEN = 'ReactModal__Content--after-open',
  CONTENT_WITHOUT_DEFAULT_ANIMATIONS = 'ReactModal__Content--without-default-animations',
  OVERLAY_BEFORE_CLOSE = 'ReactModal__Overlay--before-close',
  OVERLAY_NO_BACKDROP_BLUR = 'ReactModal__Overlay--no-backdrop-blur',
  OVERLAY_AFTER_OPEN = 'ReactModal__Overlay--after-open',
  OVERLAY_WITHOUT_DEFAULT_ANIMATIONS = 'ReactModal__Overlay--without-default-animations',
}
